<template>
    <div class="custom-upload">
        <el-upload v-show="!hideUpload" :ref="'upload_' + id" :action="url || $api.imgUploadUrl" list-type="picture-card"
            :headers="headers" :limit="limit" :class="{'limit': imgs.length == limit}"
            :on-preview="handlePictureCardPreview" :file-list="fileList" :on-success="handelChange"
            :on-remove="handleRemove">
            <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible" append-to-body :close-on-click-modal="false">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
    </div>
</template>

<script>
import { nanoid } from 'nanoid'
export default {
    data() {
        return {
            id: nanoid(),
            dialogImageUrl: '',
            dialogVisible: false,
            headers: {},
            imgs: [],
            fileList: [],
        }
    },
    props: {
        limit: {
            type: Number,
            default: 1
        },
        data: {
            type: Array,
            default: () => {
                return []
            }
        },
        editable: {
            type: Boolean,
            default: false
        },
        hideUpload: {
            type: Boolean,
            default: false
        },
        url: {
            type: String,
            default: ""
        }
    },
    watch: {
        "data": function (val) {
            this.fileList = val.map(el => {
                return {
                    name: el,
                    url: this.$api.imgBaseUrl + el
                }
            })
            this.imgs = JSON.parse(JSON.stringify(val))
        }
    },
    created() {
        this.fileList = this.data.map(el => {
            return {
                name: el,
                url: this.$api.imgBaseUrl + el
            }
        })
        this.imgs = JSON.parse(JSON.stringify(this.data))
        const userInfo = sessionStorage.getItem("admninUserInfo") ? JSON.parse(sessionStorage.getItem("admninUserInfo")) : {}
        this.headers = {
            xtoken: userInfo.token
        }
    },
    methods: {
        handelChange(response) {
            this.imgs.push(response)
            this.$emit("handelChange", this.imgs)
        },
        handleRemove(file) {
            this.imgs = this.imgs.filter(el => el != file.name)
            this.$emit("handelChange", this.imgs)
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        handleCallUpload() {
            this.$refs['upload_' + this.id].$refs['upload-inner'].handleClick()
        }
    }
}
</script>

<style lang="scss" scoped>
.custom-upload {
    position: relative;
    width: 100%;

    /deep/ .el-upload-list__item {
        transition: none !important
    }

    .limit {
        /deep/.el-upload {
            display: none;
        }
    }
}
</style>